import { render } from "./TournamentAgeCategoryList.vue?vue&type=template&id=3ad950cf&scoped=true"
import script from "./TournamentAgeCategoryList.vue?vue&type=script&lang=js"
export * from "./TournamentAgeCategoryList.vue?vue&type=script&lang=js"

import "./TournamentAgeCategoryList.vue?vue&type=style&index=0&id=3ad950cf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ad950cf"]])

export default __exports__